import { isMobile } from 'react-device-detect';

import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const Label = styled(Typography)`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  white-space: break-spaces;
  width: fit-content;
`;
export const NoValueLabel = styled(Typography)`
  color: ${({ theme }) => theme.colors.gray};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const Link = styled(Typography)`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.blue};
`.withComponent('a');

export const Flex = styled(Box)<{
  gap?: number | string;
  margin?: string;
}>`
  display: flex;
  gap: ${(props) => {
    if (typeof props.gap === 'string') return props.gap ?? '0px';

    return props?.gap ? `${props.gap}px` : '0px';
  }};
  margin: ${(props) => props.margin || 'none'};
`;

export const EmptyButton = styled(Box)`
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
`.withComponent('button');

export const MemberSelectedCard = styled(Box)<{ isSelected: boolean }>`
  cursor: pointer;
  border-radius: 16px;
  position: relative;
  transition: 0.3s;

  ${!isMobile &&
  `
    &:hover {
      box-shadow: inset -55px 1px 0px 0px ${theme.colors.green};
    }
  `}
`;

export const MemberSelectedMark = styled(Box)<{ isSelected: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  border-radius: ${({ theme }) => theme.borderRadius};
  transition: 0.3s;
  width: 100%;
  height: 100%;

  &:hover {
    box-shadow: inset -55px 1px 0 0 ${theme.colors.green};
  }

  ${({ isSelected }) =>
    isSelected &&
    `
      box-shadow: inset -55px 0 0 ${theme.colors.green}; 
    `}
`;

export const MemberCheckedIcon = styled(Box)<{ isSelected: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 18px;
  transition: 0.3s;
  z-index: 20;
  ${({ isSelected }) => `
      opacity: ${isSelected ? '1' : '0'};
      overflow: ${isSelected ? 'visible' : 'hidden'};
  `};
`;
export const BubbleWithoutBorder = styled(Box)<{
  backgroundColor?: string;
  pointer?: boolean;
}>`
  position: static;
  top: ${({ theme }) => theme.space[3]};
  right: ${({ theme }) => theme.space[3]};
  border-radius: ${({ theme }) => theme.borderRadius};
  border: none;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.space[4]} ${theme.space[5]}`};
  font-size: ${({ theme }) => theme.fontSizes['17']};
  background: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : 'rgba(238, 239, 244, 1)')};
  color: ${({ theme }) => theme.colors.black};
  ${({ pointer }) => pointer && `cursor: pointer;`}
`;
export const TabButtonList = styled(Flex)<{ marginBottom?: string }>`
  gap: 10px;
  margin-bottom: ${({ marginBottom }) => marginBottom};
  align-items: center;
  overflow-x: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const BaseImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PaperWrapper = styled(Box)`
  width: fit-content;
  padding: 10px 20px;
  border-radius: ${({ theme }) => theme.borderRadius};
  font-weight: bold;
  border: none;
  background: rgba(238, 239, 244, 1);
`;

export const PaperWrapperWithHover = styled(PaperWrapper)`
  transition: 0.3s;

  &:hover {
    background: ${({ theme }) => theme.colors.yellow800};
  }
`;

export const FormTitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  position: sticky;
  justify-content: space-between;
  top: 140px;
  flex-wrap: wrap;
  left: 0;
  background: white;
  padding: 20px 0;
  z-index: 11;

  @media (max-width: 800px) {
    top: 0;
    position: static;
  }
`;

export const TittleStyled = styled(Typography)({
  fontSize: isMobile ? theme.fontSizes[27] : theme.fontSizes[36],
  fontWeight: theme.fontWeights.extraBold,
  color: theme.colors.black,
  display: 'block',
});

export const GrayText = styled(Typography)`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => `${theme.fontSizes['17']}px`};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  width: fit-content;
`;

export const EyeWrapper = styled(Box)<{ isBlured?: boolean }>`
  position: relative;
  cursor: pointer;

  ${({ isBlured }) =>
    !isBlured &&
    `
    &::after {
      content: "";
      position: absolute;
      width: 120%;
      height: 2px;
      background: ${theme.colors.black};
      top: 10px;
      left: -10%;
      transform: rotate(-45deg);
    }
  `}
`;
